export class DBField
{
  public ColumnField: string;
  public ColumnValue: string;
}
